export const LOGIN = '@OXD/LOGIN'
export const LOGOUT = '@OXD/LOGOUT'
export const SHOW_AUTH_MODAL = '@OXD/SHOW_AUTH_MODAL'
export const HIDE_AUTH_MODAL = '@OXD/HIDE_AUTH_MODAL'
export const NAVIGATE_TO_REGISTER = '@OXD/NAVIGATE_TO_REGISTER'
export const NAVIGATE_TO_NEW_ROUTE = '@OXD/NAVIGATE_TO_NEW_ROUTE'
export const UPDATE_AUTH = '@OXD/UPDATE_AUTH'
